export class DistribuidorRevendedoraApi {
    async list(filters = null) {
        try {
            const response = await axios.get(`/distribuidor/revendedoras/list`, {
                params: filters,
            });

            return response.data;
        } catch (error) {
            console.error('Error fetching distributor resellers list:', error);
            throw error;
        }
    }

    async show(id) {
        try {
            const response = await axios.get(`/distribuidor/revendedoras/${id}`);

            return response.data;
        } catch (error) {
            console.error('Error fetching distributor reseller:', error);
            throw error;
        }
    }

    async store(data) {
        try {
            const response = await axios.post('/distribuidor/revendedoras', data);

            return response.data;
        } catch (error) {
            console.error('Error store reseller:', error);
            throw error;
        }
    }
    
    async update(data, id) {
        try {
            const response = await axios.put(`/distribuidor/revendedoras/${id}`, data);

            return response.data;
        } catch (error) {
            console.error('Error updating reseller:', error);
            throw error;
        }
    }

    async createAppAccess(data, id) {
        try {
            const response = await axios.post(`/distribuidor/revendedoras/${id}/app-acesso`, data);

            return response.data;
        } catch (error) {
            console.error('Error create app access:', error);
            throw error;
        }
    }

    async updateAppAccess(data, id) {
        try {
            const response = await axios.put(`/distribuidor/revendedoras/${id}/app-acesso`, data);

            return response.data;
        } catch (error) {
            console.error('Error updating reseller:', error);
            throw error;
        }
    }

    async createRevAccess(data, id) {
        try {
            const response = await axios.post(`/distribuidor/revendedoras/${id}/rev-acesso`, data);

            return response.data;
        } catch (error) {
            console.error('Error create rev access:', error);
            throw error;
        }
    }

    async destroy(id) {
        try {
            const response = await axios.delete(`/distribuidor/revendedoras/${id}`);

            return response.data;
        } catch (error) {
            console.error('Error deleting reseller:', error);
            throw error;
        }
    }
}


// WEBPACK FOOTER //
// ./resources/assets/js/api/DistribuidorRevendedoraApi.js